

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { register } from './registerServiceWorker';
import './components/tests/TestPrintWatermark.css';

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

// Add a version update to clear cache issues
localStorage.setItem("app_version", "v7"); // Updating to v7 to clear all caches

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker after the app is mounted
register();

